import { postData } from "@/__main__/get-data.mjs";
import router, { ROUTE_INITIATED_BY_AUTO } from "@/__main__/router.mjs";
import { appURLs } from "@/app/constants.mjs";
import noopModel from "@/data-models/no-op.mjs";
import {
  EVENT_MATCH_NATIVE_CLICK,
  EVENT_MATCH_NATIVE_VIEW,
} from "@/feature-ads/constants/events.mjs";
import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import { getUTMInfo } from "@/feature-analytics/utm.mjs";
import globals from "@/util/global-whitelist.mjs";
import { stringifyPath } from "@/util/path-regexp.mjs";

export enum AD_FORMATS {
  DISPLAY = "display",
  VIDEO = "video",
}

function getGlobalArgs() {
  return {
    route: stringifyPath(router.route.path),
    url: globals.location.href,
    referrer: globals.document?.referrer,
    routeParams: router.route.parameters,
    prevRoute: router.previousRoute?.currentPath,
    isAutomaticRedirect: router.route.initiatedBy === ROUTE_INITIATED_BY_AUTO,
    utm: getUTMInfo(),
  };
}

export function onAdView(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.AD_IMPRESSION, {
    ...getGlobalArgs(),
    ...data,
  });
}

export function onAdReport(data) {
  const payload = {
    ...getGlobalArgs(),
    ...data,
  };
  postData(
    {
      url: `${appURLs.UTILS}/api/revops/report`,
      body: JSON.stringify(payload),
    },
    noopModel,
    undefined,
  );
  return refs.trackEvent(ANALYTIC_EVENTS.AD_REPORT, payload);
}

export function onAdVideoView(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.AD_VIDEO_IMPRESSION, {
    ...getGlobalArgs(),
    ...data,
  });
}

export function onAdVideoError(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.AD_VIDEO_ERROR, {
    ...getGlobalArgs(),
    ...data,
  });
}

export function onVideoProvider(data) {
  return refs.trackEvent(ANALYTIC_EVENTS.AD_TRACK_VIDEO_PROVIDER, data);
}

export function onMatchtileClick(type) {
  return refs.trackEvent(EVENT_MATCH_NATIVE_CLICK, {
    type,
  });
}

export function onMatchtileView(type) {
  return refs.trackEvent(EVENT_MATCH_NATIVE_VIEW, {
    type,
  });
}
